import { format, parseISO } from "date-fns";
import { fullDateFullYearFormat } from "@common/helpers/date";
import { currencyFormatter } from "@common/helpers/currency";
import { sumMonetaryValues } from "@common/helpers/monetary";
import {
    BankReconciliationReportGroup,
    BankReconciliationReportTransaction,
} from "./types";

const MIN_SEARCH_LENGTH = 2;

function transactionMatchesSearch(
    transaction: BankReconciliationReportTransaction,
    search: string,
): boolean {
    const query = search.toLowerCase();
    return (
        transaction.description.toLowerCase().includes(query) ||
        (transaction.counterparty ?? "").toLowerCase().includes(query) ||
        format(parseISO(transaction.date), fullDateFullYearFormat)
            .toLowerCase()
            .includes(query) ||
        currencyFormatter
            .format(transaction.amount)
            .toLowerCase()
            .includes(query)
    );
}

export function filterTransactionGroup(
    group: BankReconciliationReportGroup,
    search: string,
): BankReconciliationReportGroup {
    if (search.length < MIN_SEARCH_LENGTH) {
        return group;
    }

    const deposits = group.deposits.filter((transaction) =>
        transactionMatchesSearch(transaction, search),
    );
    const payments = group.payments.filter((transaction) =>
        transactionMatchesSearch(transaction, search),
    );

    return {
        deposits,
        payments,
        depositsTotal: sumMonetaryValues(deposits.map((t) => t.amount)),
        paymentsTotal: sumMonetaryValues(payments.map((t) => t.amount)),
    };
}
